import { cx } from '@libs/classnames';

import { BOARD_THEMES, BoardThemes } from '../../../exports/ChessBoard';

import styles from './BoardThemePreview.module.css';

type Props = {
  boardTheme: BoardThemes;
};

export function BoardThemePreview({ boardTheme }: Props) {
  return <div className={cx(styles.boardThemePreview, BOARD_THEMES[boardTheme]?.className)} />;
}
